/** Canonical Brazil label sections (mirrors backend BRA_LABEL_SECTIONS order). */
export type BrazilSectionDefinition = {
  key: string;
  label: string;
};

export const BRAZIL_LABEL_SECTIONS: BrazilSectionDefinition[] = [
  { key: 'medicine_identification', label: 'Medicine Identification' },
  { key: 'presentations', label: 'Presentations' },
  { key: 'composition', label: 'Composition' },
  { key: 'indications', label: 'Indications' },
  { key: 'efficacy_results', label: 'Efficacy Results' },
  { key: 'pharmacological_characteristics', label: 'Pharmacological Characteristics' },
  { key: 'contraindications', label: 'Contraindications' },
  { key: 'warnings_and_precautions', label: 'Warnings and Precautions' },
  { key: 'drug_interactions', label: 'Drug Interactions' },
  { key: 'storage_instructions', label: 'Storage Instructions' },
  { key: 'posology_and_administration', label: 'Posology and Administration' },
  { key: 'adverse_reactions', label: 'Adverse Reactions' },
  { key: 'overdose', label: 'Overdose' },
  { key: 'legal_statements', label: 'Legal Statements' },
  { key: 'history_of_package_insert_changes', label: 'History of Package Insert Changes' }
];
